import { FaBinoculars, FaLeaf, FaMapMarkedAlt, FaMountain } from "react-icons/fa";
import "../css/sub-hero.css";
import { useNavigate } from "react-router-dom";

const journeyLinks = [
  {
    label: "Walking & Hiking Tours",
    path: "walkingandhikingtours",
    icon: FaMountain,
  },
  {
    label: "National Park",
    path: "nationalparks",
    icon: FaMapMarkedAlt,
  },
  {
    label: "Nature Experiences",
    path: "naturalexperiences",
    icon: FaLeaf,
  },
];

function SubHeroSection() {
  const navigate = useNavigate();

  return (
    <section className="register-section" aria-label="Kimberley adventure links">
      <div className="register-content">
        <p className="register-eyebrow">
          <FaBinoculars /> Plan something memorable
        </p>
        <h1 className="slogan-heading">
          Kimberley, Where History Glitters And Adventure Sparkles
        </h1>
        <p className="register-copy">
          Choose a scenic route, a wild escape, or a nature experience around
          the city.
        </p>

      </div>

      <div className="btns-registration" aria-label="Adventure quick links">
        {journeyLinks.map((item) => {
          const Icon = item.icon;

          return (
            <button
              type="button"
              className="btn-reg"
              key={item.path}
              onClick={() => navigate(item.path)}
            >
              <Icon />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}

export default SubHeroSection;
